import { Button } from '@bambi/component-library/src/components/Button/Button';
import type { DateRange } from '@bambi/component-library/src/components/inputs/DatePicker/DatePicker';
import DateRangePicker from '@bambi/component-library/src/components/inputs/DateRangePicker/DateRangePicker';
import { AdjustmentsHorizontalIcon } from '@heroicons/react/24/outline';
import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';

import DateRangeBadge from './DateRangeBadge';

export function hasRangeFilter(range?: DateRange) {
  return range?.from !== undefined && range.to !== undefined;
}

export function DateRangeFilter({
  dataTestId,
  dateRange,
  onDateRangeChange,
  emptyState,
}: {
  dataTestId?: string;
  // TODO: This exposes the DateRange type -- we should probably use a luxon flavored type
  // to be consistent with the rest of the app
  onDateRangeChange: (dateRange: DateRange) => void;
  dateRange?: DateRange;
  emptyState?: string | ReactNode;
}) {
  const [selectedDateRange, setSelectedDateRange] = useState<DateRange>(
    dateRange || { from: undefined, to: undefined }
  );

  useEffect(() => {
    setSelectedDateRange(dateRange || { from: undefined, to: undefined });
  }, [dateRange]);

  return (
    <div className="flex items-center gap-1">
      <DateRangePicker
        triggerElement={
          <Button dataTestId={dataTestId} className="flex items-center gap-1">
            <AdjustmentsHorizontalIcon className="mr-2 h-4 w-4" />
            <span>Date</span>
            {selectedDateRange.from && selectedDateRange.to ? (
              <div data-testid="date-range-badge">
                <DateRangeBadge
                  from={selectedDateRange.from.toISOString()}
                  to={selectedDateRange.to.toISOString()}
                  onClear={() => {
                    onDateRangeChange({ from: undefined, to: undefined });
                    setSelectedDateRange({ from: undefined, to: undefined });
                  }}
                />
              </div>
            ) : (
              emptyState
            )}
          </Button>
        }
        onDateRangeChange={(dateRange) => {
          onDateRangeChange(dateRange);
          setSelectedDateRange(dateRange);
        }}
      />
    </div>
  );
}
